import { useCallback } from "react";

import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";

export default function useRedirectToProvozniInformaceDetail() {
  const redirect = useRedirect();

  return useCallback(
    id => {
      redirect(PATHS.PROVOZNI_INFORMACE.DETAIL, { id });
    },
    [redirect]
  );
}
